"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMobile = exports.Print = exports.PrintFormat = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const faPrint_1 = require("@fortawesome/free-solid-svg-icons/faPrint");
const react_ui_1 = require("@yanzi/react-ui");
const jspdf_1 = __importDefault(require("jspdf"));
const react_1 = require("react");
const useOLMap_1 = require("../../openlayers/useOLMap");
const formats_1 = require("./formats");
Object.defineProperty(exports, "PrintFormat", { enumerable: true, get: function () { return formats_1.PrintFormat; } });
const MM_PER_INCH = 25.4;
function Print(_a) {
    var { onPrint } = _a, rest = __rest(_a, ["onPrint"]);
    const [show, setShow] = react_1.useState(true);
    react_1.useEffect(() => {
        if (isMobile()) {
            setShow(false);
        }
    }, []);
    const [modal, trigger] = react_ui_1.useFormModal({
        title: 'Save to PDF',
        fields: {
            format: {
                type: 'select',
                label: 'Format',
                options: Object.entries(formats_1.formatNames).map(([value, label]) => ({ label, value })),
                defaultValue: formats_1.PrintFormat.a4,
            },
            resolution: {
                type: 'select',
                label: 'Resolution',
                options: formats_1.resolutions.map(value => ({ label: `${value}dpi`, value: `${value}` })),
                value: formats_1.resolutions[formats_1.resolutions.length - 1],
            },
        },
    });
    const map = useOLMap_1.useOLMap();
    if (!show) {
        return null;
    }
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx(react_ui_1.FloatingActionButton, Object.assign({ label: "Print", onClick: () => __awaiter(this, void 0, void 0, function* () {
                    const { format: formatString, resolution: resolutionString } = yield trigger();
                    const format = Number(formatString);
                    const resolution = parseInt(resolutionString);
                    document.body.style.cursor = 'progress';
                    const dimension = formats_1.printFormatDimensions[format];
                    const widthInches = Math.round((dimension[0] * resolution) / MM_PER_INCH);
                    const heightInches = Math.round((dimension[1] * resolution) / MM_PER_INCH);
                    const mapSize = map.getSize();
                    const viewResolution = map.getView().getResolution();
                    map.once('rendercomplete', function () {
                        const mapCanvas = document.createElement('canvas');
                        mapCanvas.width = widthInches;
                        mapCanvas.height = heightInches;
                        const mapContext = mapCanvas.getContext('2d');
                        if (!mapContext) {
                            throw new Error('No context in canvas.');
                        }
                        drawBackground(mapContext, [widthInches, heightInches]);
                        map
                            .getTargetElement()
                            .querySelectorAll('.ol-layer canvas')
                            .forEach((canvas) => {
                            var _a, _b, _c;
                            if (!(canvas instanceof HTMLCanvasElement)) {
                                return;
                            }
                            if (!(canvas.width > 0)) {
                                return;
                            }
                            const parentNode = canvas.parentNode;
                            if (!parentNode || !('style' in parentNode)) {
                                return;
                            }
                            const opacity = parentNode.style.opacity;
                            mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
                            const transform = canvas.style.transform;
                            const matrix = (_c = (_b = (_a = transform === null || transform === void 0 ? void 0 : transform.match(/^matrix\(([^(]*)\)$/)) === null || _a === void 0 ? void 0 : _a[1]) === null || _b === void 0 ? void 0 : _b.split(',')) === null || _c === void 0 ? void 0 : _c.map(Number);
                            if (matrix) {
                                CanvasRenderingContext2D.prototype.setTransform.apply(mapContext, matrix);
                            }
                            mapContext.drawImage(canvas, 0, 0);
                        });
                        const doc = new jspdf_1.default('landscape', undefined, formats_1.PrintFormat[format]);
                        doc.addImage(mapCanvas.toDataURL('image/jpeg'), 'JPEG', 0, 0, dimension[0], dimension[1]);
                        map.setSize(mapSize);
                        map.getView().setResolution(viewResolution);
                        document.body.style.cursor = 'auto';
                        onPrint(doc);
                    });
                    map.setSize([widthInches, heightInches]);
                    var scaling = Math.min(widthInches / mapSize[0], heightInches / mapSize[1]);
                    map.getView().setResolution(viewResolution / scaling);
                }), icon: faPrint_1.faPrint }, rest), void 0), modal] }, void 0));
}
exports.Print = Print;
function drawBackground(mapContext, [widthInches, heightInches]) {
    mapContext.fillStyle = '#fff';
    mapContext.fillRect(0, 0, widthInches, heightInches);
}
function isMobile() {
    const a = navigator.userAgent || navigator.vendor || window.opera;
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
        return true;
    }
    return false;
}
exports.isMobile = isMobile;
exports.default = Print;
//# sourceMappingURL=index.js.map